var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sidebar" }, [
    _c("div", { staticClass: "section search-form" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [_c("itinerary-adv-form", { attrs: { localization: "sidebar" } })],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section news" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", [_vm._v("Aktualności")]),
            _vm._v(" "),
            _c("h2", [_vm._v("Sprawdź także")]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("ul", { staticClass: "list-icons list-unstyled" }, [
            _c("li", [
              _c("a", { attrs: { href: "#" } }, [
                _vm._v("Zmiany w tabeli  kursowania pociągów Intercity"),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("a", { attrs: { href: "#" } }, [
                _vm._v(
                  " W czasie pandemii Fitch potwierdza długoterminowy rating PKP Intercity na poziomie BBB+"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("a", { attrs: { href: "#" } }, [
                _vm._v(
                  "Apel PKP Intercity: zaplanujmy wcześniej podróże w związku z 1 listopada"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("a", { attrs: { href: "#" } }, [
                _vm._v("Zmiany w tabeli  kursowania pociągów Intercity"),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-outline-primary mb-3 mt-0 mb-md-auto mt-md-auto",
              attrs: { type: "button" },
            },
            [_vm._v("\n            Zobacz więcej\n          ")]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section newsletter-form" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", [_vm._v("Newsletter")]),
            _vm._v(" "),
            _c("h2", [_vm._v("Bądz na bieżąco")]),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            Jeżeli chcesz otrzymywać informacje o planowanych zmianach w rozkładach jazdy, nowych promocjach zapisz się do naszego newslettera.\n          "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "form",
            {
              staticClass: "g-3 needs-validation ic-form",
              attrs: { novalidate: "" },
            },
            [
              _c(
                "div",
                { staticClass: "input-group mb-3 icon icon__envelope" },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: {
                      type: "email",
                      id: "",
                      placeholder: "Adres e-mail",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "m-1 mt-3" }, [
                _c("div", { staticClass: "form-check mt-3" }, [
                  _c("input", {
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      value: "",
                      id: "invalidCheck",
                      required: "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label font-size-xs",
                      attrs: { for: "invalidCheck" },
                    },
                    [
                      _vm._v(
                        "\n                    Wyrażam zgodę na przetwarzanie moich danych osobowych, zgodnie z Rozp. Parlamentu Europejskiego i Rady (UE) 2016/679.\n                    kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE.\n                  "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info mt-3",
                    attrs: { type: "submit" },
                  },
                  [_vm._v("Zapisz się")]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }